import React from "react";
import { PaymentReceiptListComponent } from "./payment-receipt-list.component";

export const PaymentReceiptListPage = () => <PaymentReceiptListComponent />;
